<template>
  <div id="ShopHome">
    <!-- <Header class="mainHeader"></Header> -->
    <router-view @getFocus="showBottom"></router-view>
    <!-- <keep-alive> -->
      <bottomNav v-show="flag" :tab='changeIndex' :viewName="'homepage'"></bottomNav>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
// import Header from '../../view/header'
import bottomNav from '../../components/bottomNavigation'
import wxshare from '../../wx/weixin'
export default {
  components: {
    // Header,
    bottomNav
  },
  data () {
    return {
      changeIndex: '',
      flag: Boolean
    }
  },
 
  methods: {
    showBottom (val) {
      this.flag = val
    },
    addUserInfo () {
      this.utils.isUserLogin()
      if (localStorage.getItem('isLogin') === '1') {
        this.utils.get(this.companyUrl + '/ent/json', null, res => {
          localStorage.setItem('userinfo', JSON.stringify(res.data))
        })
      }
    },
    getToken: function (info) {
      this.getAccountToken(info.token)
    },
    getAccountToken: function (token) {
      // Toast('账户绑定====')
      // 自动绑定消防云与中消在线 账户
      // 相等于 登录接口
      var _this = this
      this.utils.post(this.accountUrl + '/account/xfy/binding?token=' + token, null, res => {
        // Toast('账户绑定====成功')
        _this.addUserInfo()
      })
    }
  },
  created () {
    if (this.$route.query.initTab !== undefined) {
      localStorage.setItem('tab', 0)
    }
  },
  mounted () {
    wxshare.wxShareHomePage('【中消在线】消防安全产品一站式采购平台', '品质保障，正品低价，支持线上交易', 'http://cdn.zxzx119.com/1294196519632633856')
    // 消防云app 跳转中消商城
    if (parseInt(localStorage.getItem('enterType')) === 1 && parseInt(localStorage.getItem('isApp')) === 1) {
      if (this.utils.isIphone() === true) {
        // 挂载回调
        window.sendToken = this.getToken
        // 调ios
        window.webkit.messageHandlers.getToken.postMessage(null)
      } else {
        this.getAccountToken(window.zxzx.getToken())
      }
    } else {
      this.addUserInfo()
    }

    let path = this.$route.path
    let number = 0
    switch (path) {
      case '/homePage/goodslist':
        number = 0
        localStorage.setItem('tab', number)
        this.changeIndex = number
        break
      case '/homePage/shoppingCart':
        number = 1
        localStorage.setItem('tab', number)
        this.changeIndex = number
        break
      case '/homePage/personHomePage':
        number = 2
        localStorage.setItem('tab', number)
        this.changeIndex = number
        break
      default:
        break
    }
  },
watch:{
 
},
  beforeRouteUpdate (to, from, next) {
    switch (to.path) {
      case '/homePage/goodslist':
        this.changeIndex = 0;
        localStorage.setItem('tab', this.changeIndex)
        next()
        break
      case '/homePage/shoppingCart':
        this.changeIndex = 1
        localStorage.setItem('tab', this.changeIndex)
        next()
        break
      case '/homePage/personHomePage':
        this.changeIndex = 2
        localStorage.setItem('tab', this.changeIndex)
        next()
        break
      case '/homePage/login':
        next()
        break
      case '/login':
        next()
        break
      default:
        next()
        break
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === '/home') {
      localStorage.setItem('tab', 0)
      this.changeIndex = 0
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.mainHeader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/homePage.vue